import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import { PermissionSet } from '@/Network/Types/Responses/AuthorizationResponses'

export default class AuthorizationService extends Service {
  prefix: string

  constructor() {
    super()
    this.prefix = '/users/me'
  }

  /**
   * @param bypassCache manda `Cache-Control: no-cache`. A resposta do backend vem
   * com `private, max-age=300`, entao sem isto um refetch logo apos uma mutacao
   * pode ser servido pelo cache do proprio browser, sem tocar a rede.
   */
  async getMyPermissions(companyId?: number | string, bypassCache = false): Promise<PermissionSet> {
    try {
      const query = companyId ? `?companyId=${companyId}` : ''
      const url = this.getCompletePath(`/permissions${query}`)

      const { data } = await request.get<PermissionSet>(
        url,
        undefined,
        bypassCache ? { 'Cache-Control': 'no-cache', Pragma: 'no-cache' } : undefined
      )

      return data
    } catch (error) {
      console.error('Erro ao buscar permissões do usuário:', error)
      throw error
    }
  }
}
